import { ButtonProps } from "@headlessui/react";

import { ButtonHTMLAttributes, JSX } from "react";
import { useTranslation } from "react-i18next";

import Button from "@/components/buttons/Button.tsx";
import { MODAL_ROUTES } from "@/components/modals/router/ModalRoutes";

import useModalRouter from "@/hooks/useModalRouter";

export type AddCardModalTypes = null | "card" | "otp";

const AddCardModal = ({ className }: ButtonHTMLAttributes<ButtonProps>): JSX.Element => {
  const { t } = useTranslation();

  const { openModal } = useModalRouter();

  return (
    <>
      <Button
        size={"medium"}
        aria-label={t("Payment.add-card")}
        onClick={() => openModal([MODAL_ROUTES.CREDIT_CARD, MODAL_ROUTES.CREDIT_CARD_ADD])}
        className={className}
      >
        {t("Payment.add-card")}
      </Button>
    </>
  );
};

export default AddCardModal;
